import { faClipboard, faHandPointer, faPaperPlane, faThumbsUp } from "@fortawesome/free-regular-svg-icons"
import { faAlignLeft, faArrowPointer, faClapperboard, faEarListen, faFilm, faHeadphonesSimple, faHighlighter, faPlus, faScissors } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react" 
import LazyImage from "../general/lazyImage"
import Translate from '../general/translate';

const TagLine = () => {

  return (
    <div className="pt-6 pb-6">
      <div className="text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
        <h1 className="text-[7vw] sm:text-7xl font-black md:font-extrabold mb-8 md:mb-12 text-center opacity-90">
          <span className="block"><Translate id="tagline.automatePodcast" foldername="home" filename="home-tagline" /></span>
          <span className="block"><Translate id="tagline.productionPromotion" foldername="home" filename="home-tagline" /></span>
        </h1>
          <p className="mb-12 text-xl font-normal">
          <span className="block opacity-70 mb-4 md:mb-0"><Translate id="tagline.launchGrow" foldername="home" filename="home-tagline" /></span>
          <span className="block"><span className="opacity-70"><Translate id="tagline.uploadGenerate" foldername="home" filename="home-tagline" /></span><span className="font-extrabold text-[#FFCA1D] opacity-100"><Translate id="tagline.singleClick" foldername="home" filename="home-tagline" /></span></span>  
            </p>
          <div className="flex flex-wrap justify-center gap-4 mb-12 max-w-[1100px] m-auto text-xl md:text-2xl font-bold">
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faAlignLeft} className="text-[#F39A7B]"/>
              <span><a href="/podcast-transcription/" className="hover:underline"><Translate id="tagline.transcripts" foldername="home" filename="home-tagline" /></a></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
            <FontAwesomeIcon icon={faHighlighter} className="text-[#3ADAD9]" />
              <span><Translate id="tagline.showNotes" foldername="home" filename="home-tagline" /></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faPaperPlane} className="text-[#FFCA1D]"/>
              <span><Translate id="tagline.newslettersBlogs" foldername="home" filename="home-tagline" /></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faThumbsUp} className="text-[#4A81EC]"/>
              <span><Translate id="tagline.socialPosts" foldername="home" filename="home-tagline" /></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faFilm} className="text-[#FFCA1D]"/>
              <span><Translate id="tagline.shortClipsAudiograms" foldername="home" filename="home-tagline" /></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faArrowPointer} className="text-[#F39A7B]"/>
              <span><Translate id="tagline.podcastWebsite" foldername="home" filename="home-tagline" /></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faHeadphonesSimple} className="text-[#3ADAD9]"/>
              <span><Translate id="tagline.aiAudioEnhancement" foldername="home" filename="home-tagline" /></span>
            </div>
            <div className="flex items-center py-2 px-4 bg-[#4B22A1] bg-opacity-30 rounded-lg shadow space-x-2">
              <FontAwesomeIcon icon={faScissors} className="text-[#4A81EC]"/>
              <span><Translate id="tagline.removeSilences" foldername="home" filename="home-tagline" /></span>
            </div>
          </div>
      <a href="/squeeze">
        <button className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#27004F] font-bold text-xl px-8 py-4 mb-3 rounded-[8px] shadow hover:shadow-lg no-underline focus:no-underline">
          <Translate id="tagline.generateNow" foldername="home" filename="home-tagline" />
        </button>
      </a>
      <p className="text-sm text-white mb-12 opacity-70"><Translate id="tagline.noCreditCard" foldername="home" filename="home-tagline" /></p>
                
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-2 text-center">
        <div className="p-6 rounded-lg">
          <img
            src="/home/rob-walling.webp"
            alt="Rob Walling"
            className="h-14 w-14 rounded-full mx-auto mb-2"
          />
          <h3 className="text-sm font-extrabold opacity-80"><Translate id="testimonial.robWalling.title" foldername="home" filename="home-tagline" /></h3>
          <p className="text-sm text-white opacity-80"><Translate id="testimonial.robWalling.subtitle" foldername="home" filename="home-tagline" /></p>
          <div className="flex justify-center my-2">
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
          </div>
          <p className="text-white opacity-80 italic text-sm w-5/6 m-auto leading-tight">
            <Translate id="testimonial.robWalling.quote" foldername="home" filename="home-tagline" />
          </p>
        </div>

        <div className="p-6 rounded-lg">
        <img
            src="/home/johny-gamet.webp"
            alt="John Garmet"
            className="h-14 w-14 rounded-full mx-auto mb-2"
          />
          <h3 className="text-sm font-extrabold opacity-80"><Translate id="testimonial.johnGarmet.title" foldername="home" filename="home-tagline" /></h3>
          <p className="text-sm text-white opacity-80"><Translate id="testimonial.johnGarmet.subtitle" foldername="home" filename="home-tagline" /></p>
          <div className="flex justify-center my-2">
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
          </div>
          <p className="text-white opacity-80 italic text-sm w-5/6 m-auto leading-tight">
            <Translate id="testimonial.johnGarmet.quote" foldername="home" filename="home-tagline" />
          </p>
        </div>

        <div className="p-6 rounded-lg">
          <img
            src="/home/dave-jackson.webp"
            alt="David Jackson"
            className="h-14 w-14 rounded-full mx-auto mb-2"
          />
          <h3 className="text-sm font-extrabold opacity-80"><Translate id="testimonial.davidJackson.title" foldername="home" filename="home-tagline" /></h3>
          <p className="text-sm text-white opacity-80"><Translate id="testimonial.davidJackson.subtitle" foldername="home" filename="home-tagline" /></p>
          <div className="flex justify-center my-2">
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
            <svg className="h-4 w-4 text-[#FFCA1D]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 15l-5.878 3.09 1.122-6.545L.49 6.545l6.562-.955L10 0l2.948 5.59 6.562.955-4.754 4.09 1.122 6.545z"/>
            </svg>
          </div>
          <p className="text-white opacity-80 italic text-sm w-5/6 m-auto leading-tight">
            <Translate id="testimonial.davidJackson.quote" foldername="home" filename="home-tagline" />
          </p>
        </div>
        </div>
        </div>
        </div>
        </div>   
  )
}

export default TagLine